/* eslint-disable camelcase */
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18n-react';

let autoComplete;

const loadScript = (url, callback) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';

  if (script.readyState) {
    script.onreadystatechange = () => {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
};

const addressGenerator = (addressObject, addressType) => addressObject.filter((item) => {
  if (item.types.includes(addressType)) {
    return item;
  }
});

// TODO: rewrite addressGenerator for cleaner code

const handlePlaceSelect = (updateQuery, setAddress) => {
  const addressObject = autoComplete.getPlace();
  const { address_components } = addressObject;
  const streetName = addressGenerator(address_components, 'route')[0].long_name;
  const streetNumber = addressGenerator(address_components, 'street_number')[0];
  const address = streetNumber ? `${streetName} ${streetNumber.long_name}` : `${streetName}`;
  const fullAddress = {
    address,
    postalCode: addressGenerator(address_components, 'postal_code')[0] ? addressGenerator(address_components, 'postal_code')[0].long_name : '',
    city: addressGenerator(address_components, 'administrative_area_level_2')[0] ? addressGenerator(address_components, 'administrative_area_level_2')[0].long_name : '',
    province: addressGenerator(address_components, 'administrative_area_level_1')[0] ? addressGenerator(address_components, 'administrative_area_level_1')[0].long_name : '',
    country: addressGenerator(address_components, 'country')[0] ? addressGenerator(address_components, 'country')[0].long_name : '',
  };
  updateQuery(address);
  setAddress(fullAddress);
};

const handleScriptLoad = async (updateQuery, autoCompleteRef, setAddress) => {
  let countryCode;
  await fetch('https://pro.ip-api.com/json?key=lsCvt9AP5YqiVgL')
    .then(response => response.json())
    .then(data => countryCode = data.countryCode);
    // alert(countryCode);
  autoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    { types: ['address'], componentRestrictions: { country: countryCode } },
  );
  autoComplete.setFields(['address_components', 'formatted_address']);
  autoComplete.addListener('place_changed', () =>
    handlePlaceSelect(updateQuery, setAddress));
};

const SearchLocationInput = (props) => {
  const { setAddress } = props;
  const [query, setQuery] = useState('');
  const autoCompleteRef = useRef(null);

  useEffect(() => {
    loadScript(
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyBpfyrBMTrgHH3YnaGHxfjEN_w7OXBJoqc&libraries=places',
      () => handleScriptLoad(setQuery, autoCompleteRef, setAddress),
    );
  }, []);

  return (
    <input
      ref={autoCompleteRef}
      onChange={event => setQuery(event.target.value)}
      name="reg_address"
      className="reg_address"
      placeholder={i18n.translate('loginScreen.fields.address')}
      value={query}
      autoComplete="off"
    />
  );
};

SearchLocationInput.propTypes = {
  setAddress: PropTypes.func.isRequired,
};

export default SearchLocationInput;
